import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class DewPointAttribute extends Sensor {
  public dewPointChart: any;
  private dewPointSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.dewPointChart = null;
    this.dewPointSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.dewPointSensor, position);
      this.dewPointSensor[position].push([timestamp, element.dewPoint]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredDewPoint = this.dewPointSensor.filter(series => series.length > 0);

    const positionNodeDewPoint = this.dewPointSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.dewPointChart = this.getConfigChar(
      'dewPoint',
      this.getChartSeriesNewNode('Sensor', filteredDewPoint, positionNodeDewPoint),
      this.getRanges('dewPoint'),
      this.getLimits('dewPoint')
    );
  }

  public hasDewPointSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.dewPointSensor.length &&
      this.dewPointSensor[index].length > 0
    );
  }

  public getDewPointSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.dewPointSensor.length) {
      const sensorData = this.dewPointSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Temperatura De Rocío', value: 'dewPoint' }
    ];
  }
}
